import { Outlet } from 'react-router';
import { useAuthInit, useAuthService } from '@vivli/core/infrastructure/hook';
import { ModalContextWrapper } from './modal-context.wrapper';
import { ToastContainer } from 'react-toastify';
import { Color } from '@vivli/shared/theme';
import { useEffect, useState } from 'react';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { useAuthEventsContext } from '@vivli/core/infrastructure/context';

const toastStyle: any = {
    backgroundColor: 'rgb(80, 80, 80, 0.8)',
    color: Color.WHITE,
    pointerEvents: 'all',
    cursor: 'pointer',
    fontSize: 12,
    lineHeight: 1,
    '@media print': {
        display: 'none'
    }
};

export const PlatformInitWrapper = () => {
    const [isLoading, setIsLoading] = useState(true);

    // initialize auth AFTER router has been built so it can use router methods
    useAuthInit();

    const authEvents = useAuthEventsContext();

    useEffect(() => {
        const sub = authEvents.subscribe((event) => {
            switch (event) {
                case 'get-user-info-success':
                case 'get-user-info-failure':
                case 'login-failure':
                case 'logout-success':
                    setIsLoading(false);
                    break;
            }
        });

        return () => {
            sub.unsubscribe();
        };
    }, []);

    return (
        <>
            {isLoading ? <LoadIndicatorCenteredView /> : <Outlet />}
            <ModalContextWrapper />
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={true}
                closeOnClick={true}
                toastStyle={toastStyle}
                style={{ zIndex: 20000 }}
                closeButton={true}
                limit={1}
            />
        </>
    );
};
